<template>
  <div>
    <CreKokuban @get-list="getConstructionList" :constructionList="constructionList" v-if="$route.name === 'create-kokuban'" />
    <router-view :constructionList="constructionList" />
  </div>
</template>

<script>
import store from '../store'
export default {
  name: 'CreateKokuban',
  computed: {
    constructionList() {
      return this.$store.getters['api/result/cloudConstructionList'];
    }
  },
  components: {
    CreKokuban: () => import('../components/cloud/CreKokuban.vue')
  },
  beforeRouteEnter(to, from, next) {
    const args = {};
    store.dispatch('api/getCloudConstructionList', args).then(() => {
      if (store.getters['api/apiError']) {
        next(false);
        return;
      }
      next();
    })
  },
  methods: {
    getConstructionList() {
      const args = {};
      this.$store.dispatch('api/getCloudConstructionList', args).then(() => {
        if (this.$store.getters['api/apiError']) {
          return;
        }
      })
    }
  }
}
</script>

<style scoped>
</style>